//import { useState, useRef } from "react";
import { useEffect, useCallback, useState, useRef } from "react";
import { useDocument } from "hooks/useDocument";
import { useFile } from "hooks/useFile";
import DashboardLayout from "components/templates/DashboardLayout";
import Topnav from "components/organisms/Topnav";
//import Grid from "@mui/material/Grid";
import MDBox from "components/atoms/MDBox";
import React from "react";
import { Grid, Row, Col, Panel, Card, Text, Button } from "rsuite";
import HlsDrawerPlayer from "./HlsDrawerPlayer";
//import * as images from "../../images/charts";
//import EyeRoundIcon from "@rsuite/icons/EyeRound";
//import HlsPlayer from "./hls";
//import "./draggable.css";
import "rsuite/dist/rsuite.min.css";

const StatusPanelRelay = ({ relayValue, label }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      //border: "2px solid red",
    }}
  >
    {relayValue === "OFF" ? (
      <Panel
        bordered={true}
        shaded
        backgroundColor={"grey"}
        style={{ padding: "0px", margin: "0px" }}
      >
        <div
          style={{
            color: "lightgrey",
            fontSize: "24px",
            fontWeight: "bold",
            //border: "2px solid red",
          }}
        >
          {relayValue}
        </div>
      </Panel>
    ) : relayValue === "ON" ? (
      <Panel
        bordered={true}
        shaded
        backgroundColor={"seagreen"}
        style={{ padding: "0px", margin: "0px" }}
      >
        <div
          style={{
            color: "lightgrey",
            fontSize: "24px",
            fontWeight: "bold",
            //border: "2px solid red",
          }}
        >
          {relayValue}
        </div>
      </Panel>
    ) : null}
    <div
      style={{
        fontSize: "18px",
        fontWeight: "lighter",
      }}
    >
      {label}
    </div>
  </div>
);

const StatusCard = ({
  header,
  relayValue1,
  relayValue2,
  relayValue3,
  relayValue4,
  label1,
  label2,
  label3,
  label4,
}) => (
  <Card size="md" shaded>
    <Card.Header
      backgroundColor={"blue"}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "12px",
      }}
    >
      <Text
        size="lg"
        style={{
          textAlign: "left",
          width: "100%",
          color: "white",
        }}
      >
        {header}
      </Text>
    </Card.Header>
    <Card.Body
      style={{
        border: "4px solid #2196F3",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-evenly",
          height: "100%",
        }}
      >
        <StatusPanelRelay relayValue={relayValue1} label={label1} />
        <StatusPanelRelay relayValue={relayValue2} label={label2} />
        <StatusPanelRelay relayValue={relayValue3} label={label3} />
        <StatusPanelRelay relayValue={relayValue4} label={label4} />
      </div>
    </Card.Body>
  </Card>
);

const collectionPath = "results";

function ShowLiveView() {
  const { retrieveDoc, retrieveDocs } = useDocument();
  const { getFileRef } = useFile();
  const runOnceRef = useRef(true);
  const url_sstd1raw = useRef(null);
  const url_sstd1proc = useRef(null);
  const url_sstd2raw = useRef(null);
  const url_sstd2proc = useRef(null);
  const url_sstd3raw = useRef(null);
  const url_sstd3proc = useRef(null);
  const url_sstd4raw = useRef(null);
  const url_sstd4proc = useRef(null);
  const url_floodmarker1 = useRef(null);
  const isDetected_floodmarker1 = useRef(null);
  const url_floodmarker2 = useRef(null);
  const isDetected_floodmarker2 = useRef(null);
  const relay1Value = useRef("OFF");
  const relay2Value = useRef("OFF");
  const relay3Value = useRef("OFF");
  const relay4Value = useRef("OFF");
  const analytic1Value = useRef("Unavailable");
  const analytic2Value = useRef("Unavailable");
  const analytic3Value = useRef("Unavailable");
  const analytic4Value = useRef("Unavailable");
  const [refreshCounter, setRefreshCounter] = useState(0); // State to trigger re-render

  //console.log("Render ShowLiveView, refreshCounter:", refreshCounter);
  const ImagePanel = ({ header, url_raw, url_proc, relayState }) => (
    <Card size="md" shaded>
      <Card.Header
        backgroundColor={"blue"}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "6px",
        }}
      >
        <Text
          size="lg"
          style={{
            textAlign: "left",
            width: "100%",
            color: "white",
          }}
        >
          {header}
        </Text>
        {relayState === "ON" ? (
          <Button
            appearance="ghost"
            size="lg"
            style={{
              color: "white",
              borderColor: "white",
              fontWeight: "bold",
              //backgroundColor: "lightgrey",
            }}
          >
            Relay ON
          </Button>
        ) : (
          <Button
            appearance="ghost"
            size="lg"
            style={{
              color: "silver",
              borderColor: "white",
              //backgroundColor: "lightgrey",
            }}
          >
            Relay OFF
          </Button>
        )}
      </Card.Header>
      <Card.Body
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px",
        }}
      >
        <Grid
          style={{
            padding: "0px",
            margin: "0px",
            width: "100%",
          }}
        >
          <Row gutter={[0, 0]}>
            <Col span={{ xs: 12 }}>
              {!!url_proc && (
                <img
                  className="chart-img"
                  src={url_proc}
                  alt="Camera View"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </Col>
            <Col span={{ xs: 12 }}>
              {url_raw && (
                <img
                  className="chart-img"
                  src={url_raw}
                  alt="Camera View"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </Col>
          </Row>
        </Grid>
      </Card.Body>
    </Card>
  );

  const FloodMarkerPanel = ({
    url_floodmarker1,
    url_floodmarker2,
    isDetected_floodmarker1,
    isDetected_floodmarker2,
  }) => (
    <Card size="md" shaded>
      <Card.Header
        backgroundColor={"blue"}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "6px",
        }}
      >
        <Text
          size="lg"
          style={{
            textAlign: "left",
            width: "100%",
            color: "white",
          }}
        >
          Flood Marker
        </Text>
        {isDetected_floodmarker1 && isDetected_floodmarker2 ? (
          <Button
            appearance="ghost"
            size="lg"
            style={{
              color: "white",
              borderColor: "white",
              fontWeight: "bold",
              //backgroundColor: "lightgrey",
            }}
          >
            Both Detected
          </Button>
        ) : (isDetected_floodmarker1 && !isDetected_floodmarker2) ||
          (!isDetected_floodmarker1 && isDetected_floodmarker2) ? (
          <Button
            appearance="ghost"
            size="lg"
            style={{
              color: "white",
              borderColor: "white",
              fontWeight: "bold",
              //backgroundColor: "lightgrey",
            }}
          >
            One Detected
          </Button>
        ) : !isDetected_floodmarker1 && !isDetected_floodmarker2 ? (
          <Button
            appearance="primary"
            size="lg"
            style={{
              color: "red",
              borderColor: "red", //"2px solid red",
              fontWeight: "bold",
              backgroundColor: "white",
            }}
          >
            FLOOD ALERT
          </Button>
        ) : null}
      </Card.Header>
      <Card.Body
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px",
        }}
      >
        <Grid
          style={{
            padding: "0px",
            margin: "0px",
            width: "100%",
          }}
        >
          <Row gutter={[0, 0]}>
            <Col span={{ xs: 12 }}>
              {!!url_floodmarker1 && (
                <img
                  className="chart-img"
                  src={url_floodmarker1}
                  alt="Camera View"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </Col>
            <Col span={{ xs: 12 }}>
              {!!url_floodmarker2 && (
                <img
                  className="chart-img"
                  src={url_floodmarker2}
                  alt="Camera View"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </Col>
          </Row>
        </Grid>
      </Card.Body>
    </Card>
  );

  const validateOperation = useCallback(async () => {
    try {
      //console.log("Accessing GCP");
      //const now = new Date();
      //console.log(now.toLocaleTimeString());
      const retrievedLiveResults = await retrieveDoc(collectionPath, "live");

      const data = retrievedLiveResults.data;
      relay1Value.current = data.sstd1Relay;
      analytic1Value.current = data.sstd1Analytic;

      relay2Value.current = data.sstd2Relay;
      analytic2Value.current = data.sstd2Analytic;

      relay3Value.current = data.sstd3Relay;
      analytic3Value.current = data.sstd3Analytic;

      relay4Value.current = data.sstd4Relay;
      analytic4Value.current = data.sstd4Analytic;

      //sstd1raw
      const sstd1rawQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd1raw = await retrieveDocs(
        "sstd1raw",
        sstd1rawQueries,
      );
      url_sstd1raw.current = retrievedDocs_sstd1raw[0]?.data?.url
        ? retrievedDocs_sstd1raw[0].data.url
        : null;

      //sstd1proc
      const sstd1procQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd1proc = await retrieveDocs(
        "sstd1proc",
        sstd1procQueries,
      );
      url_sstd1proc.current = retrievedDocs_sstd1proc[0]?.data?.url
        ? retrievedDocs_sstd1proc[0].data.url
        : null;

      let unixTSNow = Math.floor(new Date().getTime() / 1000);
      let timeElapsed = unixTSNow - retrievedDocs_sstd1proc[0]?.data?.unixts;
      let isDataStale = timeElapsed / 3600 > 7; // Consider data stale if older than 7 hours
      if (isDataStale) {
        const fileRef = await getFileRef(retrievedDocs_sstd1proc[0].data.path);
        url_sstd1proc.current = fileRef.url ? fileRef.url : null;
      }

      // sstd2raw
      const sstd2rawQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd2raw = await retrieveDocs(
        "sstd2raw",
        sstd2rawQueries,
      );
      url_sstd2raw.current = retrievedDocs_sstd2raw[0]?.data?.url
        ? retrievedDocs_sstd2raw[0].data.url
        : null;

      // sstd2proc
      const sstd2procQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd2proc = await retrieveDocs(
        "sstd2proc",
        sstd2procQueries,
      );
      url_sstd2proc.current = retrievedDocs_sstd2proc[0]?.data?.url
        ? retrievedDocs_sstd2proc[0].data.url
        : null;

      timeElapsed = unixTSNow - retrievedDocs_sstd2proc[0]?.data?.unixts;
      isDataStale = timeElapsed / 3600 > 7; // Consider data stale if older than 7 hours
      if (isDataStale) {
        const fileRef = await getFileRef(retrievedDocs_sstd2proc[0].data.path);
        url_sstd2proc.current = fileRef.url ? fileRef.url : null;
      }

      //sstd3raw
      const sstd3rawQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd3raw = await retrieveDocs(
        "sstd3raw",
        sstd3rawQueries,
      );
      url_sstd3raw.current = retrievedDocs_sstd3raw[0]?.data?.url
        ? retrievedDocs_sstd3raw[0].data.url
        : null;

      //sstd3proc
      const sstd3procQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd3proc = await retrieveDocs(
        "sstd3proc",
        sstd3procQueries,
      );
      url_sstd3proc.current = retrievedDocs_sstd3proc[0]?.data?.url
        ? retrievedDocs_sstd3proc[0].data.url
        : null;

      timeElapsed = unixTSNow - retrievedDocs_sstd3proc[0]?.data?.unixts;
      isDataStale = timeElapsed / 3600 > 7; // Consider data stale if older than 7 hours
      if (isDataStale) {
        const fileRef = await getFileRef(retrievedDocs_sstd3proc[0].data.path);
        url_sstd3proc.current = fileRef.url ? fileRef.url : null;
      }

      // sstd4raw
      const sstd4rawQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd4raw = await retrieveDocs(
        "sstd4raw",
        sstd4rawQueries,
      );
      url_sstd4raw.current = retrievedDocs_sstd4raw[0]?.data?.url
        ? retrievedDocs_sstd4raw[0].data.url
        : null;

      // sstd4proc
      const sstd4procQueries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_sstd4proc = await retrieveDocs(
        "sstd4proc",
        sstd4procQueries,
      );
      url_sstd4proc.current = retrievedDocs_sstd4proc[0]?.data?.url
        ? retrievedDocs_sstd4proc[0].data.url
        : null;

      const floodmarker1Queries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_floodmarker1 = await retrieveDocs(
        "fm1",
        floodmarker1Queries,
      );
      url_floodmarker1.current = retrievedDocs_floodmarker1[0]?.data?.url
        ? retrievedDocs_floodmarker1[0].data.url
        : null;
      isDetected_floodmarker1.current = retrievedDocs_floodmarker1[0]?.data
        ?.isDetected
        ? retrievedDocs_floodmarker1[0]?.data?.isDetected
        : null;

      const floodmarker2Queries = {
        whereQueries: [
          {
            field: "unixts",
            condition: "!=",
            value: null,
          },
        ],
        orderByQueries: [
          {
            field: "unixts",
            direction: "desc",
          },
        ],
        limitQuery: {
          number: 1,
        },
      };

      const retrievedDocs_floodmarker2 = await retrieveDocs(
        "fm2",
        floodmarker2Queries,
      );
      url_floodmarker2.current = retrievedDocs_floodmarker2[0]?.data?.url
        ? retrievedDocs_floodmarker2[0].data.url
        : null;
      isDetected_floodmarker2.current = retrievedDocs_floodmarker2[0]?.data
        ?.isDetected
        ? retrievedDocs_floodmarker2[0]?.data?.isDetected
        : null;
      console.log(
        "isDetected_floodmarker2.current: ",
        isDetected_floodmarker2.current,
      );

      timeElapsed = unixTSNow - retrievedDocs_sstd4proc[0]?.data?.unixts;
      isDataStale = timeElapsed / 3600 > 7; // Consider data stale if older than 7 hours
      if (isDataStale) {
        const fileRef = await getFileRef(retrievedDocs_sstd4proc[0].data.path);
        url_sstd4proc.current = fileRef.url ? fileRef.url : null;
      }

      setRefreshCounter(refreshCounter + 1); // Trigger re-render
    } catch (err) {
      console.log(err);
    }
  }, [retrieveDoc, retrieveDocs, refreshCounter, getFileRef]);

  useEffect(() => {
    if (runOnceRef.current) {
      validateOperation();
      runOnceRef.current = false; // Set to false after the first run
    }

    const intervalId = setInterval(() => {
      validateOperation();
    }, 10000); // Run every 10 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [validateOperation]);

  return (
    <DashboardLayout>
      <Topnav title={"LIVE VIEW"} />
      <MDBox p={2} pt={6}>
        <HlsDrawerPlayer
          src1={
            "https://storage.googleapis.com/pub-upwrp-sstd-ipcam-streams/sstdcam1/index.m3u8"
          }
          src2={
            "https://storage.googleapis.com/pub-upwrp-sstd-ipcam-streams/sstdcam2/index.m3u8"
          }
        />
        {/*<HlsDrawerPlayer src="http://localhost:4000/index.m3u8" />*/}
      </MDBox>
      <Grid fluid>
        <Row gutter={[9, 24]}>
          <Col span={{ xs: 24, md: 12 }}>
            <StatusCard
              header="System Status"
              relayValue1={"ON"}
              label1={"Processor 1"}
              relayValue2={"ON"}
              label2={"Processor 2"}
              relayValue3={"ON"}
              label3={"Camera 1"}
              relayValue4={"ON"}
              label4={"Camera 2"}
            />
          </Col>
          <Col span={{ xs: 24, md: 12 }}>
            <StatusCard
              header="Actuator Status"
              relayValue1={relay1Value.current}
              label1={"Actuator 1"}
              relayValue2={relay2Value.current}
              label2={"Actuator 2"}
              relayValue3={relay3Value.current}
              label3={"Actuator 3"}
              relayValue4={relay4Value.current}
              label4={"Actuator 4"}
            />
          </Col>
          <Col span={{ xs: 24, md: 12 }}>
            <FloodMarkerPanel
              url_floodmarker1={url_floodmarker1.current}
              url_floodmarker2={url_floodmarker2.current}
              isDetected_floodmarker1={isDetected_floodmarker1.current}
              isDetected_floodmarker2={isDetected_floodmarker2.current}
            />
          </Col>
          <Col span={{ xs: 24, lg: 12 }}></Col>
          <Col span={{ xs: 24, lg: 12 }}>
            <ImagePanel
              header="SSTD Outlet 1"
              url_raw={url_sstd1raw.current}
              url_proc={url_sstd1proc.current}
              relayState={relay1Value.current}
            />
          </Col>
          <Col span={{ xs: 24, lg: 12 }}>
            <ImagePanel
              header="SSTD Outlet 2"
              url_raw={url_sstd2raw.current}
              url_proc={url_sstd2proc.current}
              relayState={relay2Value.current}
            />
          </Col>
          <Col span={{ xs: 24, lg: 12 }}>
            <ImagePanel
              header="SSTD Outlet 3"
              url_raw={url_sstd3raw.current}
              url_proc={url_sstd3proc.current}
              relayState={relay3Value.current}
            />
          </Col>
          <Col span={{ xs: 24, lg: 12 }}>
            <ImagePanel
              header="SSTD Outlet 4"
              url_raw={url_sstd4raw.current}
              url_proc={url_sstd4proc.current}
              relayState={relay4Value.current}
            />
          </Col>
        </Row>
      </Grid>
    </DashboardLayout>
  );
}

export default ShowLiveView;
